import React, { useState } from "react";
import { animateScroll as scroll } from "react-scroll";
import { FaBars } from "react-icons/fa";
import Loggo from "../images/loggo.png";
import Navlink from "react-router-dom";
import { FaDownload } from "react-icons/fa";

export const Navigation = (props) => {
  const scrollToTop = () => {
    scroll.scrollToTop();
  };
  const [navbarOpen, setNavbarOpen] = useState(false);

  function active() {
    var header = document.getElementById("ul");
    var btns = header.getElementsByClassName("btn");
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function () {
        var current = document.getElementsByClassName("active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";
      });
    }
  }
  return (
    <>
      <nav
        id="navbar"
        className="navbar-default overflow-x-hidden navbar rounded bg-[#002e5b] flex  px-4 py-5 w-full fixed z-[100] "
      >
        <div className="md:container md:mx-auto flex flex-wrap items-center md:justify-between md:relative w-full">
          <div className="w-full flex justify-between items-center lg:w-auto lg:static lg:block lg:justify-start">
            <div className="flex flex-col justify-center items-center">
              <a href="/" className="" onClick={scrollToTop}>
                <div className=" flex justify-center items-center gap-5">
                 {/* <h1 className="text-white text-[17px] font-[700]">MATRIX RESOURCES LTD</h1> */}
                 <div className=" w-[200px] h-12">
                  
                 <img src={Loggo} alt="" className="md:ml-5"/>
                 </div>
                </div>
              </a>
            </div>
            <div>
              <button
                className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded block lg:hidden outline-none focus:outline-none"
                type="button"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                {/* <i className="fa fa-bars"></i> */}
                <FaBars className="text-white" />
              </button>
            </div>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center  bg-[#002e5b] lg:bg-transparent lg:shadow-none" +
              (navbarOpen ? " block rounded " : " hidden")
            }
            id="navbar-warning"
          >
            <ul className="md:flex navbar-nav list-none lg:ml-auto items-center justify-center  ">
              <li className=" flex flex-col items-center text-center justify-ceneter">
                <a
                  href="#header"
                  className=" btn px-3 xs:py-1 md:py-2 flex text-center items-center  uppercase font-[500] leading-snug text-white"
                  onClick={scrollToTop}
                >
                  Home
                </a>
              </li>
              <li className="nav-item flex flex-col items-center text-center justify-ceneter">
                <a
                  href="#features"
                  className="btn px-3 xs:py-1 md:py-2 flex items-center md:text-md uppercase font-[500] leading-snug text-white"
                >
                  About Us
                </a>
              </li>
              <li className="nav-item flex flex-col items-center text-center justify-ceneter">
                <a
                  href="#Solution"
                  className="btn px-3 xs:py-1 md:py-2 flex items-center md:text-md uppercase font-[500] leading-snug text-white"
                >
                  Services
                </a>
              </li>
              <li className="nav-item flex flex-col items-center text-center justify-ceneter">
                <a
                  href="#team"
                  className="btn px-3 xs:py-1 md:py-2 flex items-center md:text-md uppercase font-[500] leading-snug text-white"
                >
                  Testimonials
                </a>
              </li>
              <li className="nav-item flex flex-col items-center text-center justify-ceneter">
                <a
                  href="#contact"
                  className="btn px-3 xs:py-1 md:py-2 flex items-center md:text-md uppercase font-[500] leading-snug text-white"
                >
                  Contact
                </a>
              </li>

        
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
